import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=5b07f810&scoped=true&"
import script from "./ProductGroup.vue?vue&type=script&lang=js&"
export * from "./ProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=5b07f810&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b07f810",
  null
  
)

export default component.exports